/**
 * React Query (TanStack Query) provider configuration
 * Centralised QueryClient with sensible defaults for the WebSocket-based API
 */

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes — data is fresh for this period
      gcTime: 15 * 60 * 1000, // 15 minutes — keep unused cache entries
      retry: 1, // One retry — enough for transient WS issues, avoids 30s+ waits on cold Lambda
      retryDelay: 1000,
      refetchOnWindowFocus: false, // WS push handles real-time updates
      refetchOnReconnect: true, // Refetch when WS reconnects
    },
  },
});

export const QueryProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
